import React from 'react';
import Skeleton from 'Components/DesignSystem/Skeleton/Skeleton';
import Dropdown from 'Components/DesignSystem/Dropdown/Dropdown';
import { AVAILABILITY_OPTIONS } from './configurationConstants';
import { useConfigurationContext } from './Context/ConfigurationContext';
import { getFieldError } from './validationUtils';

type AvailabilityTabProps = {
    id?: string;
};

export const AvailabilityTab = ({ id = 'availability-tab' }: AvailabilityTabProps) => {
    const { currentConfig, isEditMode, isLoading, updateAvailability, validationErrors } = useConfigurationContext();

    const availability = currentConfig?.availability;

    const availabilityError = getFieldError(validationErrors, 'availability');

    const handleChange = (value: string | number) => {
        updateAvailability(String(value) || null);
    };

    if (isLoading) {
        return (
            <div data-testid={`${id}-loading`}>
                <div className="tw-flex tw-flex-col tw-gap-2" data-testid={`${id}-skeleton-group`}>
                    <Skeleton variant="text" width="50%" />
                    <Skeleton variant="rect" height="36px" />
                </div>
            </div>
        );
    }

    if (!availability?.availability) {
        return null;
    }

    return (
        <div data-testid={id}>
            <div data-testid={`${id}-format-dropdown-container`}>
                <Dropdown
                    label="Availability Format"
                    options={AVAILABILITY_OPTIONS}
                    value={availability.availability}
                    onChange={handleChange}
                    placeholder="Select Availability"
                    disabled={!isEditMode}
                    usePortal
                    error={!!availabilityError}
                />
            </div>
        </div>
    );
};